import { TrackEvent } from '@bnnvara/analytics';
import { useBrand } from '@bnnvara/brand';
import { FollowBrandButton as StyledFollowBrandButton } from '@bnnvara/buttons';
import React from 'react';

import { useNotifications } from '../../hooks/notifications';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import Notification from '../Notification';
import { Copy } from './Copy';
import * as S from './styled';
import { useIsFollowedByUser } from './useIsFollowedByUser';

const HAS_SUBSCRIPTIONS_KEY = 'hasSubscriptions';

const FollowBrand = () => {
  const brand = useBrand();
  const brandId = brand.id;
  const { isFollowedByUser, toggle } = useIsFollowedByUser(brandId);
  const isDesktop = useIsDesktop();
  const hasSubscriptions = process.browser
    ? Boolean(window.localStorage.getItem(HAS_SUBSCRIPTIONS_KEY))
    : false;
  const { addNotification } = useNotifications();

  const notify = () => {
    const notification = {
      action: hasSubscriptions ? 'subscribedToBrand' : 'subscribedToFirstBrand',
      slug: hasSubscriptions ? `/${brand.slug}` : '/wijzijnvoor-jijook',
      isRead: false,
      brand: {
        slug: brand.slug === 'portal' ? '' : brand.slug,
        name: brand.name,
      },
    };

    addNotification(notification);
  };

  const handleClick = () => {
    const result = toggle();

    if (result === true) {
      notify();

      TrackEvent('header', 'click', 'volgen');
    } else if (result === false) {
      TrackEvent('header', 'click', 'ontvolgen');
    }

    window.localStorage.setItem(HAS_SUBSCRIPTIONS_KEY, 'true');
  };

  return (
    <S.NotificationPosition>
      <S.FollowButtonContainer>
        <StyledFollowBrandButton
          onClick={handleClick}
          isFollowedByUser={isFollowedByUser}
        />
      </S.FollowButtonContainer>
      <S.NotificationContainer>
        {!isFollowedByUser && (
          <Notification
            visible
            type="bnnvaraFollowBrandNotification"
            horizontalPosition={isDesktop ? 'left' : 'up'}
            direction={isDesktop ? 'left' : 'up'}
            delay={1000}
            hideAfter={7000}
            onlyShowOnceEvery24Hrs
            showCloseButton={false}
          >
            {Copy}
          </Notification>
        )}
      </S.NotificationContainer>
    </S.NotificationPosition>
  );
};

export default FollowBrand;
